const AUTH_EN = Object.freeze({
  'login.title': 'Log in to<br/> your Qupital<br/> account',
  'login.subtitle': 'Welcome back! Please log in to your account',
  'login.login': 'Login',
  'login.password': 'Password',
  'login.forgot-password': 'Forgot Password',
  'login.register': 'Register',
  'forgot-password.title': 'Forgot Password',
  'forgot-password.subtitle': 'A password reset email will be sent to your email address',
  'forgot-password.completed': 'An email has been sent to your email address, please check your inbox',
  'forgot-password.go.back.to.login': 'Back to Login',
  'registration.title': 'Register Account',
  'registration.subtitle': 'Please fill in the details to register a Qupital account',
  'registration.password': 'Password',
  'registration.confirm.password': 'Confirm Password',
  'registration.lastname': 'Last Name',
  'registration.firstname': 'First Name',
  'registration.job.position': 'Job Position',
  'registration.phone.number': 'Phone Number',
  'registration.register': 'Register',
  'registration.have.account.already': 'Log in with an existing account',
  'reset-forgot-password.title': 'Reset Password',
  'reset-forgot-password.subtitle': 'Please enter a new password',
  'reset-forgot-password.password': 'New Password',
  'reset-forgot-password.confirm.password': 'Confirm New Password',
  'reset-forgot-password.reset': 'Reset Password',
  'reset-forgot-password.completed': 'Your password has been reset, please log in again',
  'reset-forgot.password.go.back.to.login': 'Back to Login',
});

export { AUTH_EN };
